import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from "react-bootstrap";
import { CreditCardFill, Cart2 } from "react-bootstrap-icons";
import '../../css/pay.css';


// onClick={() => navigate('/checkout')} заменить ссылку на ссылку оплаты, или запросить оплату ещё раз) 


const FailPage = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center  text-center px-3 pt-5 pb-5">
      <XCircle size={80} className="text-danger mb-3" />
      <h1 className="fw-bold mb-2">Оплата не удалась</h1>
      <p className=" mb-4 pt-2">
        Что-то пошло не так. Возможно, произошла ошибка при обработке платежа. Попробуйте снова или проверьте данные карты.
      </p>
      
      <div className="d-flex gap-3 flex-wrap justify-content-center pb-5" >
        <Button
          variant="outline-success"
          className="d-flex align-items-center rounded-4 custom-green-outline"
          onClick={() => navigate('/checkout')}
        >
          <CreditCardFill className="me-2" />
          Попробовать снова
        </Button>
        <Button
          variant="outline-secondary"
          className="d-flex align-items-center rounded-4 "
          onClick={() => navigate('/basket')}
        >
          <Cart2 className="me-2" />
          Вернуться в корзину
        </Button>
      </div>
    </div>
  );
};

export default FailPage;
